const Search = (props) => {
  const { placeholder = "Search" } = props;

  return (
    <div className="search-bar w-100">
      <i className="fas fa-search left-icon" />
      <input type="text" placeholder={placeholder} className="site-input" />
    </div>
  );
};

export default Search;
